const ReportHeader = () => {
  return (
    <div className="border-b-[1px] border-black pb-3">
      <div className="flex items-center justify-between">

        {/* LEFT LOGO */}
        <div className="flex items-center">
          <img
            src="/logo.png"
            alt="logo"
            className="h-20 object-contain"
          />
        </div>

        {/* RIGHT DETAILS */}
        <div className="text-right text-[12px] leading-5">

          <div>
            ABN : 94063128844
          </div>

          <div>
            2/22, MICHELLAN COURT,
            BAYSWATER, VIC 3132
          </div>

          <div>
            Australia wide - 1300 669 996
          </div>

          <div>
            sales@universalweighing.com.au
          </div>

          <div>
            www.universalweighing.com.au
          </div>

        </div>

      </div>
    </div>
  );
};

export default ReportHeader;